import React, { useEffect } from "react";
import GenericDrawer from "./GenericDrawer";
import HamburgerMenuMobile from "../MenuV2/HamburgerMenuMobile";
import { useSelector } from "react-redux";
import { MenuSelectors, SettingsSelectors } from "../../redux/selectors";
import { useDispatch } from "react-redux";
import { useClickOutside, useNoScroll } from "../../hooks";
import {
  MenuActionCreators,
  SettingsActionCreators
} from "../../redux/action-creators";
import {
  Channel,
  DrawerType,
  Topic,
  VerticalTransition
} from "../../constants";
import MobileDrawerHeader from "../MenuV2/MobileDrawerHeader";
import { MessageBrokerUtils } from "../../utils";

const useToggleDrawerOnOpenCIS = () => {
  const dispatch = useDispatch();
  const languageMenuVisible = useSelector(MenuSelectors.languageMenuVisible);
  const quickLinksInnerMenuVisible = useSelector(
    MenuSelectors.quickLinksInnerMenuVisible
  );
  const hamburgerMenuVisible = useSelector(MenuSelectors.hamburgerMenuVisible);
  const settingsDrawerActive = useSelector(
    SettingsSelectors.general.isDrawerActive
  );
  const oddsMenuVisible = useSelector(MenuSelectors.oddsMenuVisible);
  const appearanceMenuVisible = useSelector(
    MenuSelectors.appearanceMenuVisible
  );
  useEffect(() => {
    const subscription = MessageBrokerUtils.subscribe({
      channel: Channel.NAVIGATION,
      topic: Topic.performAction,
      callback: ({ actionID }, env) => {
        if (
          actionID === "openCIS" &&
          env?.headers?.publisher !== "unifiedclient"
        ) {
          if (quickLinksInnerMenuVisible) {
            dispatch(MenuActionCreators.hideQuickLinksInnerMenu());
          }
          if (languageMenuVisible) {
            dispatch(MenuActionCreators.hideLanguageMenu());
          }
          if (oddsMenuVisible) {
            dispatch(MenuActionCreators.hideOddsMenu());
          }
          if (appearanceMenuVisible) {
            dispatch(MenuActionCreators.hideAppearanceMenu());
          }

          if (settingsDrawerActive) {
            dispatch(SettingsActionCreators.toggleSettingsDrawer());
          }

          if (hamburgerMenuVisible) {
            dispatch(MenuActionCreators.hideHamburgerMenu());
          }
        }
      }
    });

    return () => {
      subscription?.unsubscribe();
    };
  }, [
    appearanceMenuVisible,
    dispatch,
    hamburgerMenuVisible,
    languageMenuVisible,
    oddsMenuVisible,
    quickLinksInnerMenuVisible,
    settingsDrawerActive
  ]);
};

const HamburgerDrawer = function () {
  const dispatch = useDispatch();

  const hamburgerMenuVisible = useSelector(MenuSelectors.hamburgerMenuVisible);

  useToggleDrawerOnOpenCIS();
  const drawerRef = useClickOutside(
    () => {
      dispatch(MenuActionCreators.hideHamburgerMenu());
    },
    {
      disabled: !hamburgerMenuVisible
    }
  );
  useNoScroll("hamburgerDrawer", hamburgerMenuVisible);

  return (
    <GenericDrawer
      componentRef={drawerRef}
      isVisible={hamburgerMenuVisible}
      menu={DrawerType.HamburgerMenu}
      hasFavoriteSport={true}
      header={<MobileDrawerHeader menu={DrawerType.HamburgerMenu} />}
      className="hamburger-drawer"
      verticalTransition={VerticalTransition.Left}
    >
      <HamburgerMenuMobile />
    </GenericDrawer>
  );
};

export default React.memo(HamburgerDrawer);
